<!-- <div class="loader-wrapper" *ngIf="loading">
  <div class="loader">
    <div class="spinner"></div>
    <div class="spinner-text">Loading...</div>
  </div>
</div> -->
@if (config.type !== 'inline') {
  <div class="loader-wrapper" *ngIf="config.isLoading">
    <div
      class="loader"
      [ngClass]="{
      'full-loader': config.type === 'full',
      'small-loader': config.type === 'small'
    }"
    >
      <!--    <img-->
      <!--      class="append_animation"-->
      <!--      src="assets/gifs/prism_loader.gif"-->
      <!--      alt="loading..."-->
      <!--    />-->
      <div class="logo">
        <img src="assets/images/smarttos-logo-small.svg">
      </div>
      
      <!-- Progress Bar Container -->
      <div class="progress-container">
        @if (config.isIndeterminate) {
          <!-- Indeterminate Progress Bar -->
          <div class="indeterminate-progress">
            <div class="progress-bar">
              <div class="progress-bar-fill"></div>
            </div>
          </div>
        } @else {
          <!-- Determinate Progress Bar -->
          <nz-progress 
            [nzPercent]="config.progress || 0" 
            nzStatus="active" 
            [nzShowInfo]="false"
            [nzStrokeWidth]="6"
            nzStrokeColor="#19b5fe">
          </nz-progress>
        }
      </div>
      
      <!-- Loading Message -->
      <div class="spinner-text">{{ config.message || 'Loading...' }}</div>
      <button
        *ngIf="config.dismissible && config.type === 'small'"
        class="dismiss-btn"
        (click)="dismiss()"
      >
        Dismiss
      </button>
    </div>
  </div>
}
